const WHITE_LIST = ['gclid', 'fbclid'];

interface PageDefault {
  [key: string]: unknown;
  gclid: string | null;
  fbclid: string | null;
}

/**
 * Return a default `options.context` object.
 */
export function pageDefaults(): PageDefault | object {
  const params = new URLSearchParams(document.location.search);
  const paramsMap = [...params.entries()];

  return paramsMap.reduce((_acc, [key, value]) => {
    if (WHITE_LIST.includes(key)) {
      return {
        ..._acc,
        [key]: value,
      };
    }
    return _acc;
  }, {});
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function enrichPageContext(ctx: any): Promise<any> {
  let pageContext = pageDefaults();
  if (Object.keys(pageContext).length) {
    const event = ctx.event;
    event.context = event.context || {};
    const pageProps = (await event.context) ?? {};

    Object.keys(pageContext).forEach((key) => {
      if (pageProps[key]) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pageContext[key] = pageProps[key];
      }
    });
    if (event.context.page) {
      pageContext = Object.assign({}, pageContext, event.context.page);
    }

    event.context = Object.assign({}, event.context, pageContext);
    ctx.event = event;
  }
  return ctx;
}

export const contextEnrichment = {
  name: 'Ad Params Injection[gclid, fbclid]',
  version: '1.0.0',
  isLoaded: () => true,
  load: () => Promise.resolve(),
  type: 'before',

  page: enrichPageContext,
  alias: enrichPageContext,
  track: enrichPageContext,
  identify: enrichPageContext,
  group: enrichPageContext,
};
